import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-partners-benefits-section',
  imports: [TuiIcon, SectionHeaderComponent],
  templateUrl: './partners-benefits-section.component.html',
  styleUrl: './partners-benefits-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnersBenefitsSectionComponent {}
